import React from "react";
import { Image, Container, Col, Row, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { MdShare, MdCall } from "react-icons/md";
import voucher from "../../assets/vou-2.png";

const ActiveVouchers = (props) => {
  const vouchers = props.vouchers;

  return (
    <>
      <div>
        {props.vouchers.length > 0 ? (
          vouchers
            .filter((item) => item.product_redeem_status === 0)
            .map((item) => {
              return (
                <Row className="local-main" key={item.euvi_id}>
                  <Col md="2" className="local-1">
                    <Image loading="lazy" src={voucher} />
                  </Col>
                  <Col>
                    <p className="vou-1">{item.business_name}</p>
                    <p className="vou-2">Voucher ID: {item.product_code}</p>
                    <p className="vou-3">{item.voucher_name}</p>
                    <p className="vou-4">Price : ${item.voucher_offer_price}</p>
                    <div className="mt-3 d-flex vou-btns">
                      <Link
                        variant="primary"
                        type="submit"
                        className="green-btn"
                        to={`/redeemconfirmation/${item.product_id.toString()}`}
                      >
                        {" "}
                        Redeem Now{" "}
                      </Link>
                      <Link
                        variant="primary"
                        type="submit"
                        className="view-btn"
                        to={`/voucherdetail/${item.product_id.toString()}`}
                      >
                        {" "}
                        View Voucher{" "}
                      </Link>
                      <MdShare className="share-btn" />
                    </div>
                  </Col>
                  <Col>
                    <Link className="view-main" to="/contactseller">
                      <p className="contact-seller">
                        <MdCall className="seller-icon" />
                        Contact Seller
                      </p>
                    </Link>
                  </Col>
                  {item.expiration_date ? (
                    <p className="ribben expires-ribben">
                      Expires in {item.expire_days} day
                    </p>
                  ) : null}
                </Row>
              );
            })
        ) : (
          <div className="d-flex justify-content-center">
            <h5>Empty list</h5>
          </div>
        )}
      </div>
    </>
  );
};

export default ActiveVouchers;
